var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_2147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 18C28 18 10.92 30.44 4 48C10.92 65.56 28 78 48 78C68 78 85.08 65.56 92 48C85.08 30.44 68 18 48 18ZM48 68C36.96 68 28 59.04 28 48C28 36.96 36.96 28 48 28C59.04 28 68 36.96 68 48C68 59.04 59.04 68 48 68ZM48 36C41.36 36 36 41.36 36 48C36 54.64 41.36 60 48 60C54.64 60 60 54.64 60 48C60 41.36 54.64 36 48 36Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_2147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.f4764e26de62080a703ada4c3da6a611.svg";
export { ForwardRef as ReactComponent };